import { Controller } from './controller'

export { Controller }
export class Application {

  private static $controllerMap: Map<string, typeof Controller> = new Map()
  private static $isStarted: boolean = false

  public static start() {
    document.addEventListener('DOMContentLoaded', () => {
      this.$isStarted = true
      for(const [name, controllerClass] of this.$controllerMap) {
        this.initController(name, controllerClass)
      }
    })
  }

  public static register(name: string, controller: typeof Controller) {
    if (this.$controllerMap.has(name)) {
      console.error(`Controller ${name} is already registered.`)
      return
    }

    this.$controllerMap.set(name, controller)

    if (this.$isStarted) {
      this.initController(name, controller)
    }
  }

  private static initController(name: string, controllerClass: typeof Controller) {
    const elements = document.querySelectorAll(`[data-controller="${name}"]`)
    elements.forEach((element) => {
      new controllerClass(element as HTMLElement)
    })
  }

}
